export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-scale/src/number.js
// module id = ../../../../d3-scale/src/number.js
// module chunks = 4